import { render, staticRenderFns } from "./AuthCode.vue?vue&type=template&id=65a2d639&scoped=true&"
import script from "./AuthCode.vue?vue&type=script&lang=js&"
export * from "./AuthCode.vue?vue&type=script&lang=js&"
import style0 from "./AuthCode.vue?vue&type=style&index=0&id=65a2d639&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a2d639",
  null
  
)

export default component.exports